module.exports = __webpack_public_path__ + "static/aikido_ai-afb4ba820c1a6290767f03d4292b7e29.svg";